import React from 'react';
import { SelectInput } from '~/components';
import { useProductsBySolutionId } from '~/hooks/product';
import { useExternalSourceTypes } from '~/hooks/externalSources';
import { Skeleton } from '@material-ui/lab';

interface PaymentInstrumentSelectProps {
  solutionId: string;
  name: string;
  source: string;
  label: string;
  value: string;
  emptyText?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  disableHelperText?: boolean;
  allowEmpty?: boolean;
  [x: string]: any;
}

const PaymentInstrumentSelect: React.FC<PaymentInstrumentSelectProps> = ({
  solutionId,
  name,
  source,
  label,
  value,
  emptyText,
  onChange,
  className,
  disableHelperText,
  allowEmpty,
  ...rest
}) => {
  const {
    data: externalSourceTypesData,
    isLoading: externalSourceTypesLoading,
  } = useExternalSourceTypes();
  const externalSourceTypes =
    externalSourceTypesData?.map((type) => ({
      value: type,
      text: type,
    })) ?? [];
  const { data: productsData, isLoading: productsLoading } = useProductsBySolutionId(solutionId);
  const products =
    productsData?.map((product) => ({
      value: product?.id,
      text: product?.name,
    })) ?? [];
  const paymentInstrumentOptions = [...(externalSourceTypes || []), ...(products || [])];

  if (externalSourceTypesLoading || productsLoading) return <Skeleton />;
  return (
    <SelectInput
      options={paymentInstrumentOptions}
      name={name}
      source={source}
      label={label}
      value={value}
      emptyText={emptyText}
      onChange={onChange}
      className={className}
      disableHelperText={disableHelperText}
      allowEmpty={allowEmpty}
      {...rest}
    />
  );
};

export default PaymentInstrumentSelect;
